import type { ObjectKeys, ObjectValues } from '@/types/HelperTypes'

export const routeNames = {
  Dashboard: 'dashboard',
  Login: 'login',
  Flows: 'flows',
  Groupes: 'groupes',
  Configuration: 'configuration',
  ConfigurationNew: 'createConfiguration',
  Editor: 'editor',
  LandingPage: 'landingPage',
  Pathway: 'pathway',
  Files: 'files',
  Profile: 'profile',
  ResetPassword: 'resetPassword',
  VerifyEmail: 'verifyEmail',
  ConfirmEmailChange: 'confirmEmailChange',
  Roles: 'roles',
  Blockly: 'blockly',
  Users: 'users',
  Statistics: 'statistics',
  ConfigurationsFinished: 'configurationFinished',
  ConfigurationFinished: 'configurationsFinished',
  ConfigurationSummary: 'configurationsSummary',
  Logs: 'logs',
  Criteria: 'criteria',
} as const

export type RouteNamesTypes = ObjectKeys<typeof routeNames>
export type RouteNameValues = ObjectValues<typeof routeNames>
